/**
 * Возраст одноразового токена публичной формы (B6) — одно число для сервера,
 * который проверяет, и браузера, который выжидает.
 *
 * Отправка быстрее двух секунд после выдачи — бот; старше получаса — протух.
 * Браузер берёт токен при первом касании формы и обновляет его перед
 * отправкой, только если тот подходит к сроку: иначе свежий токен уходил бы
 * через миллисекунды и сам себя отсекал как бот.
 */
export const NONCE_MIN_AGE_MS = 2_000
export const NONCE_MAX_AGE_MS = 30 * 60_000

/** С каким запасом до срока браузер берёт новый токен */
export const NONCE_REFRESH_AFTER_MS = NONCE_MAX_AGE_MS - 5 * 60_000
